// extracted by css-extract-rspack-plugin
export default {"area":"area-sYpB2V","header":"header-C3ST2G","title":"title-rCAQiE","description":"description-ZtDvBA"};